import gql from 'graphql-tag'

const GET_SAVE_QUERY = gql`
  mutation SaveQuery($input: SaveFileInputs!) {
    saveFile(input: $input) {
      itemFile {
        id
        key
        title
        useForPreview
      }
    }
  }
`

export default GET_SAVE_QUERY
